import { useState, useEffect } from 'react';
import { loadAnalyticsIfConsented, clearAnalyticsCookies } from '../components/cookie-consent/analyticsUtils';
import { getCookieConsent, setCookieConsent, CookieConsentData } from '../components/cookie-consent/cookieUtils';

export interface CookieConsentState {
  hasConsented: boolean | null;
  analytics: boolean;
  necessary: boolean;
}

export const useCookieConsent = () => {
  const [consentState, setConsentState] = useState<CookieConsentState>({
    hasConsented: null,
    analytics: false,
    necessary: true, // System cookies are always accepted
  });

  useEffect(() => {
    // Check if user has already made a choice
    const savedConsent = getCookieConsent();
    if (savedConsent) {
      const newState = {
        hasConsented: true,
        analytics: savedConsent.analytics,
        necessary: true, // System cookies are always accepted
      };
      setConsentState(newState);
      
      // Load analytics if previously consented
      if (newState.analytics) {
        loadAnalyticsIfConsented(newState);
      }
    }
  }, []);

  const acceptAll = () => {
    const newState = {
      hasConsented: true,
      analytics: true,
      necessary: true,
    };
    setConsentState(newState);
    setCookieConsent(newState);
    
    // Load analytics immediately
    loadAnalyticsIfConsented(newState);
  };

  const rejectAll = () => {
    const newState = {
      hasConsented: true,
      analytics: false,
      necessary: true, // System cookies are always accepted
    };
    setConsentState(newState);
    setCookieConsent(newState);
    
    // Clear analytics cookies
    clearAnalyticsCookies();
  };

  const acceptAnalytics = () => {
    const newState = {
      hasConsented: true,
      analytics: true,
      necessary: true,
    };
    setConsentState(newState);
    setCookieConsent(newState);
    
    // Load analytics immediately
    loadAnalyticsIfConsented(newState);
  };

  return {
    consentState,
    acceptAll,
    rejectAll,
    acceptAnalytics,
    hasMadeChoice: consentState.hasConsented !== null,
  };
}; 